/**
 * @generated SignedSource<<2cf0ad0097b3bd56a704e5b8ee2ac496>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentUserPermissions",
        "storageKey": null
    }, v2 = [
        (v0 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "RunningSchedulesEditSidebarQuery",
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RunningSchedulesEditSidebar_schedules"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "RunningSchedulesEditSidebarQuery",
            "selections": [
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filterModel",
                            "value": {
                                "withCurrentUserPermissions": [
                                    "EDIT_RUNNING"
                                ]
                            }
                        }
                    ],
                    "concreteType": "ScheduleConnection",
                    "kind": "LinkedField",
                    "name": "schedules",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Schedule",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v1 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "name",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "order",
                                                    "value": {
                                                        "timestampId": "ASC"
                                                    }
                                                }
                                            ],
                                            "concreteType": "ScheduleAssignmentTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "assignmentTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleAssignmentTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleAssignmentType",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleAssignmentTypeResourceConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "resources",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "totalCount",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v0 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "AssignmentType",
                                                                    "kind": "LinkedField",
                                                                    "name": "assignmentType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v0 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "title",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": "filteredResources",
                                                                    "args": null,
                                                                    "concreteType": "ScheduleAssignmentTypeResourceConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "resources",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleAssignmentTypeResourceEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ScheduleAssignmentTypeResource",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v0 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": null,
                                                                                            "kind": "LinkedField",
                                                                                            "name": "schedulableEntity",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "__typename",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        (v0 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "color",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayName",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Asset",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "asset",
                                                                                                                    "plural": false,
                                                                                                                    "selections": (v2 /*: any*/),
                                                                                                                    "storageKey": null
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "SchedulableAsset",
                                                                                                            "abstractKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "ISchedulableEntity",
                                                                                                    "abstractKey": "__isISchedulableEntity"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": (v2 /*: any*/),
                                                                                                    "type": "Node",
                                                                                                    "abstractKey": "__isNode"
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Schedule",
                                                                    "kind": "LinkedField",
                                                                    "name": "schedule",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v1 /*: any*/),
                                                                        (v0 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "assignmentTypes(order:{\"timestampId\":\"ASC\"})"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "schedules(filterModel:{\"withCurrentUserPermissions\":[\"EDIT_RUNNING\"]})"
                }
            ]
        },
        "params": {
            "cacheID": "f333a76a74af984d7182417975d01978",
            "id": null,
            "metadata": {},
            "name": "RunningSchedulesEditSidebarQuery",
            "operationKind": "query",
            "text": "query RunningSchedulesEditSidebarQuery {\n  ...RunningSchedulesEditSidebar_schedules\n}\n\nfragment RunningScheduleAssignmentType_scheduleAssignmentType_3bxOm8 on ScheduleAssignmentType {\n  id\n  assignmentType {\n    id\n    title\n  }\n  filteredResources: resources {\n    edges {\n      node {\n        id\n        schedulableEntity {\n          __typename\n          ... on ISchedulableEntity {\n            __isISchedulableEntity: __typename\n            id\n            color\n            displayName\n            ... on SchedulableAsset {\n              asset {\n                id\n              }\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment RunningSchedulesEditSidebar_schedules on Query {\n  schedules(filterModel: {withCurrentUserPermissions: [EDIT_RUNNING]}) {\n    edges {\n      node {\n        id\n        currentUserPermissions\n        name\n        assignmentTypes(order: {timestampId: ASC}) {\n          edges {\n            node {\n              resources {\n                totalCount\n              }\n              id\n              assignmentType {\n                id\n                title\n              }\n              ...RunningScheduleAssignmentType_scheduleAssignmentType_3bxOm8\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "8286592004602801243c65e4676ccea9";
export default node;
